export default "__VITE_ASSET__BRNIJRrr__"